import Joi from '@hapi/joi';
import { ForgotPassword } from 'types';
import validate from './validate';
import { emailRules } from './utils/common';

export const schema = Joi.object<Partial<ForgotPassword>>({
  email: emailRules(),
});

export default function (value: Partial<ForgotPassword>) {
  return validate(schema, value, {
    allowUnknown: false,
    context: {},
  });
}
